<template>
	<div class="container" style="position: relative;">
		<div class="notification-overlay" v-if="isVisible">
			<div class="row justify-content-end">
				<div class="col-auto">
					<div :class="['alert', `alert-${alertType}`, 'alert-dismissible', 'fade', 'show', 'fw-bold']"
						role="alert">
						<pre class="preStyle m-0 p-0">{{ message }}</pre>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
.notification-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 9999;
}
.preStyle {
    background: transparent;
}
</style>

<script>
import { mapState } from 'vuex';

export default {
	name: 'AlertMessage',
	computed: {
		...mapState(['alertMessage', 'isAlertVisible', 'alertType']),
		message() {
			return this.alertMessage;
		},
		isVisible() {
			return this.isAlertVisible;
		}
	}
};
</script>